import { FontAwesomeIcon, toCssColorValue } from "@skailer-com/uikit";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

const colorBlockTheme = {
  base: "flex items-center justify-center transition-all",
  readonly: "text-secondary",
  disabled: "text-dark/50",
  hover: "hover:border-dark/5",
  variants: {
    size: {
      sm: "w-4 h-4 rounded-xs",
      md: "w-8 h-8 rounded-sm",
      lg: "w-12 h-12 rounded-md",
    },
    iconSize: {
      sm: "",
      md: "",
      lg: "text-2xl",
    },
  },
};

export interface ColorBlockProps extends ComponentProps<"div"> {
  color: string;
  selected?: boolean;
  size?: keyof typeof colorBlockTheme.variants.size;
  onClick?: () => void;
}

export const ColorBlock = ({ color, selected = false, size = "sm", onClick }: ColorBlockProps) => {
  return (
    <div
      className={twMerge(
        colorBlockTheme.base,
        colorBlockTheme.variants.size[size],
        onClick ? "cursor-pointer" : undefined
      )}
      style={{ backgroundColor: toCssColorValue(color) }}
      onClick={onClick}
    >
      {selected && (
        <FontAwesomeIcon
          icon="fa-check fa-light text-white"
          className={colorBlockTheme.variants.iconSize[size]}
        />
      )}
    </div>
  );
};
